import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export const ImageUploadField = ({ label, field, currentValue, onInputChange, onFileUpload }) => (
  <div className="space-y-2">
    <Label>{label}</Label>
    <div className="flex items-center gap-4">
      {currentValue && (
        <div className="relative w-20 h-20 border rounded-lg overflow-hidden bg-muted">
          <img src={currentValue} alt={label} className="w-full h-full object-contain" />
        </div>
      )}
      <div className="flex-1">
        <Input
          type="file"
          accept="image/*"
          onChange={(e) => e.target.files[0] && onFileUpload(e.target.files[0], field)}
          className="cursor-pointer"
        />
      </div>
    </div>
    {currentValue && (
      <Input
        value={currentValue}
        onChange={(e) => onInputChange(field, e.target.value)}
        placeholder="URL de l'image"
        className="text-sm"
      />
    )}
  </div>
);
